import React, { useEffect } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { textdb, auth } from '../../firebase'; // Assuming firebase config is correct
import { collection } from 'firebase/firestore';
import './DisplayBlog.css'; // We'll update this CSS file
import { Link } from 'react-router-dom'; // useNavigate was imported but not used, removed for now
import { CiCalendarDate } from 'react-icons/ci';
import { Helmet } from 'react-helmet';
import { FaArrowRight } from 'react-icons/fa';
import Load from '../Load/Load'; // Assuming Load component exists

// Helper function to generate a slug (same as in BlogUpload)
const generateSlug = (text) => {
  if (!text) return ''; // Guard against undefined/null title
  return text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special chars except space and hyphen
    .replace(/\s+/g, '-')         // Replace spaces with hyphens
    .replace(/-+/g, '-')          // Replace multiple hyphens with single
    .replace(/^-+|-+$/g, '');   // Trim leading/trailing hyphens
};

export const DisplayBlog = () => {
  // const currentUser = auth.currentUser; // Not used in this component's rendering logic

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Fetch blog posts from Firestore (collection: Blogs)
  const [blogs, loading, error] = useCollection(collection(textdb, 'Blogs'));

  // Truncate a text string to a specified maximum word count.
  const truncateText = (text, maxLength) => {
    if (!text) return '';
    const words = text.split(' ');
    return words.length > maxLength
      ? words.slice(0, maxLength).join(' ') + '...'
      : text;
  };

  return (
    <div className="blog-display-container">
      <Helmet>
        <title>Blog Posts | Our Insights</title>
        <meta
          name="description"
          content="Explore our latest articles, insights, and tips on various topics."
        />
      </Helmet>

      <header className="blog-display-header">
        <h1 className="blog-display-header__title">Our Blog</h1>
        <p className="blog-display-header__subtitle">
          Fresh perspectives and actionable insights.
        </p>
      </header>

      {loading && <Load />}
      {error && <p className="blog-display-error">Error fetching blog posts. Please try again later.</p>}

      {blogs && !loading && blogs.docs.length === 0 && (
        <p className="blog-display-empty">No blog posts available yet. Check back soon!</p>
      )}

      {blogs && blogs.docs.length > 0 && (
        <div className="blog-grid">
          {blogs.docs.map((doc) => {
            const data = doc.data();
            if (!data || !data.title) { // Basic validation
                console.warn("Skipping blog post with missing data or title:", doc.id);
                return null;
            }
            // Use stored slug or generate one on the fly.
            const slug = data.slug ? data.slug : generateSlug(data.title);
            
            // Validate slug
            if (!slug) {
                console.warn("Skipping blog post due to empty slug (original title: " + data.title + "):", doc.id);
                return null;
            }

            return (
              <Link
                key={doc.id}
                to={`/blog/${slug}`}
                className="blog-card-link"
              >
                <article className="blog-card">
                  {data.iconImageUrl && (
                    <div className="blog-card__image-wrapper">
                      <img
                        loading="lazy"
                        className="blog-card__image"
                        src={data.iconImageUrl}
                        alt={data.title || 'Blog post image'}
                      />
                    </div>
                  )}
                  <div className="blog-card__content">
                    <h3 className="blog-card__title">{data.title}</h3>
                    <div className="blog-card__meta">
                      {data.timestamp && (
                        <span className="blog-card__date">
                          <CiCalendarDate className="blog-card__icon" />
                          {new Date(data.timestamp.toDate()).toLocaleDateString(
                            'en-US',
                            {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                            }
                          )}
                        </span>
                      )}
                      {data.author && (
                        <span className="blog-card__author">
                          By {data.author}
                        </span>
                      )}
                    </div>
                    <p className="blog-card__description">
                      {truncateText(data.description, 25)}
                    </p>
                    <div className="blog-card__read-more">
                      Read More <FaArrowRight className="blog-card__read-more-icon" />
                    </div>
                  </div>
                </article>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
};